import { Form, message } from 'antd'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import Context from '../Context'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import size from 'lodash/size'
import authService from 'authService'

const authApp = process.env.REACT_APP_AUTH_URL

const updateUser = async ({
  name,
  description,
  isNew
}) => {
  const path = !isNew ? 'add' : 'edit'
  const data = await axiosRequest({
    url: `/role/${path}`,
    baseURL: authApp,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    },
    data: {
      name, description,
      password: "syclone"
    }
  })

  if (size(get(data, 'response.data.error'))) throw new Error('Request Error')

  return data.data
}

const useUpdateUser = () => {
  const [form] = Form.useForm()
  const {
    states: { selectedUser, type },
    actions: { onClose, setSelectedUser, setDirtyBit }
  } = useContext(Context)

  const { isLoading, mutate } = useMutation({
    mutationKey: 'update_auth_user',
    mutationFn: updateUser,
    onSuccess: () => {
      const text = type === 'updateUser' ? "actualizado" : "creado"
      onClose()
      setSelectedUser('')
      setDirtyBit(true)
      form.resetFields()
      message.success({
        type: 'success',
        content: `El rol fue ${text} correctamente`
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = () => {
    form
      .validateFields()
      .then(() => {
        mutate({ ...form.getFieldsValue(true), uuid: selectedUser, isNew: type === 'updateUser' })
      })
      .catch(() => { })
  }

  return {
    onClick,
    form,
    isLoading
  }
}

export default useUpdateUser
